import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWriteInValue = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.6026 3C17.3601 3 17.1175 3.09281 16.9328 3.27755L4.89471 15.3156C4.89471 15.3156 5.8468 15.3203 6.31574 15.7893C6.78468 16.2582 6.77462 17.1955 6.77462 17.1955C6.77462 17.1955 7.73961 17.2132 8.21045 17.684C8.68128 18.1548 8.68413 19.105 8.68413 19.105L20.7222 7.06696C21.0926 6.69655 21.0926 6.09681 20.7222 5.72734L18.2724 3.27755C18.0877 3.09281 17.8451 3 17.6026 3ZM17.6026 5.28697L18.7128 6.39715L17.7191 7.39077L16.609 6.28059L17.6026 5.28697ZM15.2694 7.6202L16.3795 8.73038L9.1208 15.9891C8.88301 15.8262 8.63254 15.7027 8.38623 15.608C8.29339 15.3635 8.17167 15.1158 8.01062 14.8789L15.2694 7.6202ZM3.63465 17.2103L3 20.9997L6.78942 20.3651L3.63465 17.2103Z",
		fill: "currentColor"
	})
});
export default SvgWriteInValue;
